import React, { Component } from 'react'
import { Page, Accordion, FormSelect } from '../../components'
import { connect } from 'react-redux'
import { getIndicatorGeneratorDetails, fetchGoals, confirmIndicatorGenerator } from '../../api'
import { notify } from '../../utils'
import { push } from '../../actions/nav-actions'

class IndicatorGeneratorViewer extends Component {
    state = {
        loading: true,
        selectedGoals: undefined,
        indicator: undefined
    }
    componentDidMount() {
        this.fetch()
    }
    fetch = () => {
        this.setState({ loading: true })
        const { organization, code, indicator } = this.getParams()
        getIndicatorGeneratorDetails(this.props.user.token, organization, code, indicator).then((ind) => {
            return fetchGoals(this.props.user.token, organization, code).then((data) => {
                return ({
                    goals: data.goals.reduce((acc, goal) => {
                        return [...acc, goal, ...goal.subgoals]
                    }, []), indicator: ind
                })
            })
        }).then(({ indicator, goals }) => {
            this.setState({ loading: false, indicator, goals })
        }).catch(err => {
            this.setState({ loading: false })
            notify("Error", err.message, "error")
        })
    }
    getParams = () => {
        return this.props.match.params || {};
    }
    save = () => {
        if (!this.state.selectedGoals) {
            alert("Select a goal/subgoal to continue")
            return
        }
        const { organization, code, indicator } = this.getParams()
        const data = { goal: this.state.selectedGoals }
        confirmIndicatorGenerator(this.props.user.token, organization, code, indicator, data).then((indicator) => {
            notify("Project updated", "Project successfully updated!")
        }).catch(err => {
            notify("Error", err.message, "error")
        })
    }
    _render = () => {
        const { indicator, goals, selectedGoals } = this.state
        if (!indicator) return null
        return (
            <div>


                <h4>Select a goal</h4>
                <span>Select a goal or subgoal to perform this indicator. this action cannot be undone.</span>
                <br /><br />

                <FormSelect
                    className="col-4"
                    value={selectedGoals}
                    onChange={options => {
                        let { selectedGoals } = this.state;
                        selectedGoals = options.value;
                        this.setState({ selectedGoals });
                    }}
                    placeholder="Select a goal/subgoal"
                    searchable
                    options={goals.map(x => ({ value: x._id, label: x.name }))} />
                <br /><br />

                <h4>Area</h4>
                <span>{indicator.area}</span>
                <br /><br />

                <h4>Types</h4>
                <span>{indicator.type.join(', ')}</span>
                <br /><br />

                <h4>Entry Point</h4>
                <span>{indicator.entry_point.join(', ')}</span>
                <br /><br />

                <h4>Example Objective</h4>
                <span>{indicator.example_objective}</span>
                <br /><br />


                <h4>Primary Target Group</h4>
                <span>{indicator.primary_target_group.join(', ')}</span>
                <br /><br />


                <h4>Qualitative or Quantitative</h4>
                <span>{indicator.qualitative_or_quantitative}</span>
                <br /><br />


                <h4>Assumptions</h4>
                <span>{indicator.assumptions}</span>
                <br /><br />


                <h4>Type of Factor</h4>
                <span>{indicator.type_of_factor}</span>
                <br /><br />


                <h4>Collection Tools</h4>
                <span>{indicator.collection_tools.join(', ')}</span>
                <br /><br />


                <h4>Considerations</h4>
                <span>{indicator.considerations}</span>
                <br /><br />


                <h4>References</h4>
                <a href={indicator.references} target="_blank">
                    <span>{indicator.references}</span>
                </a>
                <br /><br />


                <h4>Tags</h4>
                <span>{indicator.tags.join(', ')}</span>
                <br /><br />

                <button
                    className="btn btn-info"
                    onClick={this.save}
                    style={{ marginTop: 24, marginBottom: 24 }}>
                    USE THIS GENERATOR
                </button>

            </div>
        )
    }
    render() {
        const { loading, indicator } = this.state
        return (
            <Page title="Indicator Generator">
                {loading && (
                    <span>loading...</span>
                )}
                {!loading && (
                    <React.Fragment>
                        <Accordion.Card
                            open={true}
                            title={indicator.indicator}
                            style={{ marginBottom: '60px' }}
                            component={null}>
                            {this._render()}
                        </Accordion.Card>
                    </React.Fragment>
                )}
            </Page>
        )
    }
}

const mapStateToProps = state => ({
    user: state.authReducer.user,
    resources: state.resources
})

const mapDispatchToProps = dispatch => ({
    push(routeName) {
        dispatch(push(routeName));
    }
})
export default connect(mapStateToProps, mapDispatchToProps)(IndicatorGeneratorViewer)


// WEBPACK FOOTER //
// ./src/routers/Projects/IndicatorGeneratorViewer.js